import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://yhfuowcodysbsmosgybq.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InloZnVvd2NvZHlzYnNtb3NneWJxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ4MjcxMjYsImV4cCI6MjA4MDQwMzEyNn0.h9iDsb_rqyUdo746NtPvz_NydkLNP4YYtfGOeqBJ2SU";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);